const MAX_INPUT_COUNT = 100

export default MAX_INPUT_COUNT
